<template>
  <div class="absolute close-btn z-20">
    <img src="./img/close.svg" @click="$emit('close')" class=" rounded-full p-2 bg-white w-10 h-10 cursor-pointer" alt="Close">
  </div>
</template>

<script>
export default {

}
</script>

<style lang="postcss">
.close-btn{
  position: absolute;
  top: 20px;
  right: 20px;
}
@screen lg{
  .close-btn{
    position: absolute;
    top: 40px;
    right: 40px;
  }
}
</style>
